import { useCurrentRoute } from "./useCurrentRoute";
import { useSlice } from "./useSlice";
import { processAPILink } from "utils/processAPILink";

export function useProcessedLinks() {
  // eslint-disable-next-line no-unused-vars
  const { loadState, ...apiLinks } = useSlice("apiLinks");
  const currentRoute = useCurrentRoute();
  return Object.keys(apiLinks)
    .map((key) => processAPILink(currentRoute)(apiLinks[key]))
    .reduce(reduceFunction, {});
}

function reduceFunction(previous, current) {
  const { props } = current;
  return { ...previous, [props["data-url-id"]]: props };
}
